module.exports = __webpack_public_path__ + "static/media/downVoteicon.5a67bff2.png";